export default "__VITE_ASSET__g50k1DIN__"